module.exports = __webpack_public_path__ + "static/jalf-logo-f08d719132b6cfe254fa61e3c153c512.png";